import { Container } from './Container';
import { IContainer } from './IContainer';

export class ExtensionContainer extends Container implements IContainer {}
